import { toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';

class ChatCodeBlockContextProviderService {
    constructor() {
        this._providers = ( new Map());
    }
    get providers() {
        return [...( this._providers.values())];
    }
    registerProvider(provider, id) {
        this._providers.set(id, provider);
        return toDisposable(() => this._providers.delete(id));
    }
}

export { ChatCodeBlockContextProviderService };
